import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators, ValidationErrors } from '@angular/forms';
import { Router } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSelectModule, MatSelectChange } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { SdtService } from 'src/app/services/sdt.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { RestService } from 'src/app/services/rest-service';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { AppSettings } from 'src/app/shared/app-settings';
import { DatePipe } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { timeZoneService } from 'src/app/services/timezone.service';
import moment from 'moment';
import 'moment-timezone';

@Component({
  selector: 'app-pm-form',
  templateUrl: './pm-form.component.html',
  styleUrls: ['./pm-form.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatCardModule,
    MatButtonModule,
    MatTabsModule,
    MatDialogModule
  ]
})
export class PmFormComponent implements OnInit {

  PM_Form:FormGroup
  deviceNames = [];
  pmDevices:any;
  createdBy: any;
  currentuser:any;
  data:any;
  dataLength:number;
  formattedData: any[];
  selectedDevicesLength: number;
  pmStartDate: any;
  pmEndDate: any;
  reason: any;
  otherReason: any;
  updatedBy: any;
  updatedTime: any;
  createdTime: any;
  pmdevices: any;
  siteTimezone:string;
  modifiedReason: any;
  timeZoneData: any;
  minDate: any;
  startDate: any;
  selectedTime: any;
  eventDateForComparison: any;
  currentDateForComparison: any;
  selectedStartTime: any;
  selectedEndTime: any;
  timeData: any;
  selectedDate: any;
  formattedMinDate: any;
  formattedDate: any;
  selectedEndDate: string;
  pmstartDate: string;
  pmendDate: string;
  minPmend: Date;
  timeZone: string;
  dateData: any;
  timeData1: any;

  constructor(
    private toastr: ToastrService,
    private sdtService: SdtService,
    private router: Router, private fb: FormBuilder,
    public authService: AuthenticationService,
    public restService: RestService,
    public spinner: SpinnerService,
    public dialog: MatDialog,
    private http: HttpClient,
    private datePipe: DatePipe,
    private titleService: Title,
    private timeZoneService: timeZoneService
    ) { 
      this.titleService.setTitle("Planned Maintenance Form");
      this.pmDevices = this.sdtService.selectedDevicesPM
      this.siteTimezone = localStorage.getItem('timeZone')
      this.timeZoneData = this.timeZoneService.getDateParametersByTimeZone(this.siteTimezone)['currentTime'].split(' ')[0];
      this.dateData = this.changeDateFormat1(this.timeZoneData)
      this.timeData = this.timeZoneService.getDateParametersByTimeZone(this.siteTimezone)['currentTime'].split(' ')[1].slice(0,-3);
      this.timeData1 = this.timeZoneService.getDateParametersByTimeZone(this.siteTimezone)['currentTime'].split(' ')[1];
      const [month, day, year] = this.timeZoneData?.split('/').map(Number);
      this.startDate = new Date(year, month - 1, day);
      this.minDate = new Date(year, month - 1, day); 
      this.formattedMinDate = `${this.minDate.getFullYear()}-${String(this.minDate.getMonth() + 1).padStart(2, '0')}-${String(this.minDate.getDate()).padStart(2, '0')}`;
  }

  ngOnInit(): void {
    this.pmdevices = this.sdtService.selectedDevicePM;
    this.currentuser = this.authService.currentUserValue;
    let title = this.titleService.getTitle();
    this.PM_Form = this.fb.group({
      start_date: ['', Validators.required],
      start_time: ['', Validators.required],
      end_date: ['', Validators.required],
      end_time: ['', Validators.required],
      reason: ['', Validators.required],
      otherReason: ['']
    }, { validators: this.dateRangeValidator });

    if (this.pmdevices && this.pmdevices.length > 0 && this.pmdevices !== undefined && this.pmdevices !== null) {
      this.deviceNames = this.pmdevices
        .filter(ele => ele && ele.deviceName !== undefined && ele.deviceName !== null && ele.deviceName !== '')
        .map(ele => ele.deviceName);
      }
      this.PM_Form.valueChanges.subscribe(() => {
        this.checkDateRange();
      });
      
  }

  changeDateFormat(dateString) {
    let parts = dateString.split("-");
    let year = parts[0];
    let month = parts[1];
    let day = parts[2];
    return month + "/" + day + "/" + year;
  }


  onStartDatechange(event: any){
    this.selectedDate = event.target.value;
    const date = new Date(this.selectedDate);

    this.pmstartDate = (date.getMonth() + 1).toString().padStart(2, '0') + '/'
                          + date.getDate().toString().padStart(2, '0') + '/'
                          + date.getFullYear();

    this.minPmend = new Date(this.pmstartDate)
  }

  onEndDatechange(event: any){
    this.selectedEndDate = event.target.value;
    const date = new Date(this.selectedEndDate);
    this.pmendDate = (date.getMonth() + 1).toString().padStart(2, '0') + '/'
                      + date.getDate().toString().padStart(2, '0') + '/'
                      + date.getFullYear();
  }


  areDatesEqual(dt1, dt2) {
    const date1 = moment(dt1);
    const date2 = moment(dt2);
    return date1.isSame(date2, 'day');
  }

  onStartTimeChange(event: any){
    this.selectedStartTime = event.target.value;
        const [selectedHours, selectedMinutes] = this.selectedStartTime.split(":").map(Number);
        const selectedTotalMinutes = selectedHours * 60 + selectedMinutes;

        const [timeDataHours, timeDataMinutes] = this.timeData.split(":").map(Number);
        const timeDataTotalMinutes = timeDataHours * 60 + timeDataMinutes;
        if ((this.areDatesEqual(this.pmstartDate,this.changeDateFormat(this.timeZoneData)))&&(selectedTotalMinutes < timeDataTotalMinutes)) {
            this.selectedStartTime = this.timeData;
            event.target.value = this.timeData;
            this.PM_Form.get('start_time').setValue(this.timeData);
        }
    }

  onEndTimeChange(event: any){
    this.selectedEndTime = event.target.value;

    const [selectedHours, selectedMinutes] = this.selectedEndTime.split(":").map(Number);
    const selectedTotalMinutes = selectedHours * 60 + selectedMinutes;

    const [timeDataHours, timeDataMinutes] = this.selectedStartTime.split(":").map(Number);
    const timeDataTotalMinutes = timeDataHours * 60 + timeDataMinutes;

    if((this.areDatesEqual(this.selectedEndDate,this.selectedDate))&&(selectedTotalMinutes < timeDataTotalMinutes)){
      this.selectedEndTime = this.selectedStartTime;
      event.target.value = this.selectedStartTime;
      this.PM_Form.get('end_time').setValue(this.selectedStartTime);
    }

  }
  

  checkDateRange() {
    const startDate = this.PM_Form.get('start_date').value;
    const endDate = this.PM_Form.get('end_date').value;
    if (startDate && endDate && new Date(startDate).getTime() > new Date(endDate).getTime()) {
      this.toastr.warning('End date must be greater than start date.')
    }
  }


  dateRangeValidator: ValidatorFn = (group: FormGroup): ValidationErrors | null => {
    const startDate = group.get('start_date').value;
    const endDate = group.get('end_date').value;
    return startDate && endDate && new Date(startDate) > new Date(endDate) ? { 'dateRangeInvalid': true } : null;
  };

  Reason: string[] = [
    'Customer Power',
    'Customer Internet',
    'Pro-Fit Maintenance',
    'Other'
  ];  

  changeReason(event: MatSelectChange) {
    const selectedReason = event.value;
    
    switch (selectedReason) {
      case 'Customer Power':
        this.modifiedReason = 'customer_power';
        break;
      case 'Customer Internet':
        this.modifiedReason = 'customer_internet';
        break;
      case 'Pro-Fit Maintenance':
        this.modifiedReason = 'profit_maintenance';
        break;
      case 'Other':
        this.modifiedReason = 'Other';
        this.PM_Form.get('otherReason').enable();
        break;
      default:
        this.modifiedReason = null;
        this.PM_Form.get('otherReason').disable();
        this.PM_Form.get('otherReason').setValue('');
        break;
    }
  }
  

  isSelectedReasonOther(): boolean {
    return this.PM_Form.get('reason').value === 'Other';
  }


  formatPM() {
  if (this.PM_Form) {
    const startDate = new Date(this.PM_Form.value.start_date);
    const startMonth = ('0' + (startDate.getMonth() + 1)).slice(-2);
    const startDay = ('0' + startDate.getDate()).slice(-2);
    const startYear = startDate.getFullYear();
    this.pmStartDate = startMonth + '-' + startDay + '-' + startYear;

    const endDate = new Date(this.PM_Form.value.end_date);
    const endMonth = ('0' + (endDate.getMonth() + 1)).slice(-2);
    const endDay = ('0' + endDate.getDate()).slice(-2);
    const endYear = endDate.getFullYear();
    this.pmEndDate = endMonth + '-' + endDay + '-' + endYear;

    this.reason = this.PM_Form.value.reason ? this.PM_Form.value.reason : this.PM_Form.value.otherReason;

    const now = new Date();
    const options: Intl.DateTimeFormatOptions = {
      timeZone: 'UTC',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    };
    const formatter = new Intl.DateTimeFormat('en-US', options);
    const formattedDate = formatter.format(now).replace(/\//g, '-');
    
    this.createdTime = formattedDate;
    this.updatedTime = formattedDate;
  }
}


  formatData(startDate, endDate, reason, createdBy) {
    this.data = this.pmdevices;
    this.dataLength=this.data.length;
    if (this.data && this.dataLength > 0) {
      this.formattedData = [];
      for (let i = 0; i < this.dataLength; i++) {
        this.formattedData.push({
          accId: this.data[i]['accId'],
          potentialId: this.data[i]['potentialId'],
          siteUnitId: this.data[i]['siteUnitId'],
          siteName: this.data[i]['siteName'],
          siteType: this.data[i]['siteType'],
          deviceUniqueId: this.data[i]['deviceUniqueId'],
          deviceName: this.data[i]['deviceName'],
          deviceType: this.data[i]['deviceType'],
          type: this.data[i]['type'],
          pdStartDate: startDate.slice(0, -8) + this.selectedStartTime + ':00' || '',
          pdEndDate: endDate.slice(0, -8) + this.selectedEndTime + ':00' || '',
          pdReason: reason === 'Other' ? this.PM_Form.get('otherReason').value : reason,
          createdAt: this.dateData + ' '+ this.timeData1,
          updatedAt: this.dateData + ' '+ this.timeData1,
          createdBy: this.createdBy,
          updatedBy: this.createdBy,
        })
    }
    return this.formattedData;
  }
}

  formatDateTime(dateStr: string): string {
    const date = new Date(dateStr);
    const formattedDate = [
      ('0' + (date.getMonth() + 1)).slice(-2),
      ('0' + date.getDate()).slice(-2),
      date.getFullYear()
    ].join('-');
    const formattedTime = [
      ('0' + date.getHours()).slice(-2),
      ('0' + date.getMinutes()).slice(-2),
      '00'
    ].join(':');

    return `${formattedDate} ${formattedTime}`;
  }

  changeDateFormat1(dateString) {
    let parts = dateString.split("-");
    let year = parts[0];
    let month = parts[1];
    let day = parts[2];
    return month + "-" + day + "-" + year;
  }

  onSubmit() {
    if (!this.PM_Form.valid) {
       return false
     } else {
      this.formatPM()
      const formData = this.PM_Form.value;
      let startDate = this.formatDateTime(formData.start_date);
      let endDate = this.formatDateTime(formData.end_date);
      this.createdBy = this.currentuser.email
      const reason = this.PM_Form.get('reason')?.value;
    
      let sentData = this.formatData(startDate,endDate,reason,this.createdBy);
      const apiUrl = AppSettings.API_ENDPOINT + '/' + AppSettings.PM_CREATE;
      this.http.post(apiUrl, sentData).subscribe((response) => {}, error => {});
      this.router.navigateByUrl('/monitors');
      this.toastr.success('Planned Maintenance Saved Successfully')
    }   
  }

  back(){
    this.router.navigateByUrl('/monitors')
  }
}
